import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { User, MapPin, Calendar, CheckCircle, CreditCard, Briefcase, Star, TrendingUp, Award, X, Edit, Camera, Shield, Phone, Globe, MessageSquare, Bookmark, ListChecks, Clock, Sun, FileText, Moon } from 'lucide-react';
import { API_BASE_URL } from '../config';
import Avatar from "./ui/Avatar";
import { jwtDecode } from 'jwt-decode';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Badge from "./ui/Badge";
import Button from "./ui/Button";
import Card from "./ui/Card";
import styles from './BusinessProfilePureCSS.module.css';
import PortfolioLightbox from '../search/PortfolioLightbox'; // Assuming this is the correct path
import api from '../api/api.js';
import { useNavigate } from 'react-router-dom';

const BusinessProfilePureCSS = ({ isOpen, onClose, businessId, useIDTYPE, showMessageButton = true }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isRendered, setIsRendered] = useState(false);
  const [selectedPortfolioItem, setSelectedPortfolioItem] = useState(null);
  const [isSaved, setIsSaved] = useState(false);

 const navigate = useNavigate();



  const checkIfSaved = async () => {
      try {
          const token = localStorage.getItem('token');
          if (!token) return;

          const decodedToken = jwtDecode(token);
          const userType = decodedToken.UserType;
          
          const homeUserId = parseInt(localStorage.getItem('homeUserId'), 10) || 0;
          const bizUserId  = parseInt(localStorage.getItem('businessId'), 10) || 0;

          
          const params = new URLSearchParams({
              savedBusinessId: profile.businesses.businessId,
              userType,
          });

          if (userType === 'Home') {
              params.append('homeUserId', homeUserId);
          } else {
              params.append('businessId', bizUserId);
          }

          const { data } = await axios.get(
              `${API_BASE_URL}/api/BusinessProfile/isBusinessFavourite?${params.toString()}`,
              { headers: { Authorization: `Bearer ${token}` } }
          );

          if (typeof data.isFavourite === 'boolean') {
              setIsSaved(data.isFavourite);
          }
      } catch (err) {
          console.error('Error checking favourite status', err);
      }
  };

  const handleSaveFavourite = async () => {
      try {
          const token = localStorage.getItem('token');
          if (!token) {
              toast.error("You must be logged in to save a business.");
              return;
          }
          const decodedToken = jwtDecode(token);
          const userType = decodedToken.UserType;

          const loggedInHomeUserId  = parseInt(localStorage.getItem('loggedInHomeUserId'), 10)  || 0;
          const loggedInBusinessId  = parseInt(localStorage.getItem('loggedInBusinessId'), 10)  || 0;

          const payload = {
              savedBusinessId: profile.businesses.businessId,
              homeUserId: userType === 'Home' ? loggedInHomeUserId : 0,
              businessId: userType === 'Business' ? loggedInBusinessId : 0,
              userType,
              commend: ''
          };

          const { data } = await api.post(
              `/api/BusinessProfile/toggleBusinessFavourite`,
              payload,
              { headers: { Authorization: `Bearer ${token}` } }
          );

          if (data.status === 'saved' || data.status === 'removed') {
              const newIsSaved = data.status === 'saved';
              setIsSaved(newIsSaved);
              toast.success(newIsSaved ? 'Added to your favourites' : 'Removed from your favourites');
          } else {
              toast.error('Unexpected response from server.');
          }
      } catch (err) {
          console.error(err);
          toast.error('Could not update favourite status.');
      }
  };

  // --- MODIFICATION 1: GENERALIZE getDirections TO ACCEPT AN ADDRESS ---
  const getDirections = (address) => {
    if (!address) {
      toast.error("Address is not available.");
      return;
    }
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
    } else {
      const timer = setTimeout(() => setIsRendered(false), 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isOpen && businessId) {
      const fetchBusinessProfile = async () => {
        setLoading(true);
        setError(null);
        try {

          var url = "";
          if (useIDTYPE == "BID") {
            //url = `${API_BASE_URL}/api/BusinessProfile/getBusinessProfile?businessId=${businessId}`;
            url = `/api/BusinessProfile/getBusinessProfile?businessId=${businessId}&logView=true`;
          } else {
            //url = `${API_BASE_URL}/api/BusinessProfile/getBusinessProfileWithBUID?businessUserId=${businessId}`;
            url = `/api/BusinessProfile/getBusinessProfileWithBUID?businessUserId=${businessId}`;
          }

          console.log(`Getting url = ${url}`);


          //const response = await fetch(url);
          const response = await api.get(url);
          console.log(`response.data = ${response.data}`);

          //if (!response.ok) {
          //  throw new Error('Network response was not ok');
          //}

          //const data = await response.json();
          setProfile(response.data);
        } catch (error) {
          setError(error.message);
        } finally {
          setLoading(false);
        }
      };
      fetchBusinessProfile();
    }
  }, [isOpen, businessId, useIDTYPE]);

  useEffect(() => {
    if (profile) {
      checkIfSaved();
    }
  }, [profile]);

  if (!isRendered) return null;

const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`${styles.starIcon} ${i < Math.round(rating) ? styles.starFilled : styles.Empty}`}
      />
    ));
};




    const handleMessageClickConcise = async (quote) => {
        //setLoading(true);
        try {

            console.log(`Checking param: ${quote.businessuserid}`);
    
            // 1. Grab your auth token, decode it:
            const token = localStorage.getItem('token');
            if (!token) {
            navigate('/login');
            return;
            }
            const { nameid: currentUserId, UserType } = jwtDecode(token);


            const myuserType = localStorage.getItem('userType');
            let url = "";


            // 2. Build the three query params that NewConversation expects:
            //    - always need senderBusinessUserId
            //    - supply either homeUserId OR receiverBusinessUserId
            const isHome = myuserType === 'Home';

            const senderBusinessUserId = isHome
            ? quote.businessuserid    // if I'm a Home‐user, I pass the Business I'm talking to
            : currentUserId;              // otherwise I (a Business) pass my own ID
    
            const homeUserId = isHome
            ? currentUserId               // Home user passes themselves
            : undefined;
    
            const receiverBusinessUserId = !isHome
            ? quote.businessuserid   // Business talking to another Business
            : undefined;
    
            console.log(`currentUserId = ${currentUserId}`);
            console.log(`senderBusinessUserId = ${senderBusinessUserId}`);
            console.log(`receiverBusinessUserId = ${receiverBusinessUserId}`);
            console.log(`homeUserId = ${homeUserId}`);
    
    
            // 3. Assemble and call the NewConversation endpoint:
            //senderBusinessUserId=123&homeUserId=456

            if (myuserType == "Home")
            {
                url = `senderBusinessUserId=${senderBusinessUserId}&homeUserId=${homeUserId}`;
            }
            else
            {
                url = `senderBusinessUserId=${senderBusinessUserId}&receiverBusinessUserId=${receiverBusinessUserId}`;                
            }

            const { data } = await api.get(
            `/api/Chat/NewConversation?${url}`
            );
    
            // 4. Pull out the conversationId and open the right route in a new tab
            const { conversationId } = data;
            const path = isHome
            ? `/home_messages?conversationId=${conversationId}`
            : `/business_messages?conversationId=${conversationId}`;
    
            window.open(path, '_blank', 'noopener,noreferrer');
        } catch (err) {
            console.error('Error starting conversation:', err);
        } finally {
            //setLoading(false);
        }
    };






  const primaryLocation = profile?.locations?.find(loc => loc.isPrimary);

  return (
    <div className={`${styles.profileModalOverlay} ${isOpen ? styles.overlayVisible : ''}`} onClick={onClose}>
      <div
        className={`${styles.profileModal} ${isOpen ? styles.visible : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        {loading ? (
          <div className={styles.loadingContainer}>Loading...</div>
        ) : error ? (
          <div className={styles.errorContainer}>Error: {error}</div>
        ) : !profile ? (
          <div className={styles.errorContainer}>No profile data found.</div>
        ) : (
          <>
            {/* --- START OF REDESIGNED JSX --- */}
            
            {/* Close Button remains at the top right */}
            <Button variant="ghost" size="sm" onClick={onClose} className={styles.profileCloseBtn}>
                <X className="w-5 h-5" />
            </Button>

            {/* New Profile Header - Two Column Layout */}
            <div className={styles.profileHeader}>
                <div className={styles.headerContent}>
                    {/* --- LEFT COLUMN: IDENTITY & TRUST --- */}
                    <div className={styles.identity}>
                        <Avatar
                            className={styles.profileLogo}
                            src={profile.businesses.profilePic || "/placeholder.svg"}
                            fallback={profile.businesses.businessName.charAt(0)}
                        />
                        <div className={styles.identityText}>
                            <h1>{profile.businesses.businessName}</h1>
                            <p className={styles.tagline}>{profile.businesses.description}</p>


                    <div className={styles.ratingInfo}>
                        <div className={styles.starsContainer}>{renderStars(profile.statistics.averageRating)}</div>
                        <strong>{profile.statistics.averageRating?.toFixed(1)}</strong>
                        <span>({profile.statistics.reviewCount || 0} Reviews)</span>
                    </div>

                    {profile.statistics.googleRating && profile.statistics.googleRatingCount > 0 && (
                        <div className={`${styles.ratingInfo} ${styles.googleRatingInfo}`}>
                            <Globe size={14} className={styles.googleIcon}/>
                            <strong>Google Rating: {profile.statistics.googleRating.toFixed(1)}</strong>
                            <span>({profile.statistics.googleRatingCount} Reviews)</span>
                        </div>
                    )}
                            
                            
                            
                            <div className={styles.badgeContainer}>
                                {profile.businesses.fullyInsured && <div className={styles.badge}><Shield size={14}/> Fully Insured</div>}
                                {profile.businesses.yearsExperience > 0 && <div className={styles.badge}><Award size={14}/> {profile.businesses.yearsExperience} Years Experience</div>}
                                {profile.businesses.afterHours !== 0 && <div className={styles.badge}><Clock size={14}/> After Hours</div>}
                                {profile.businesses.weekends !== 0 && <div className={styles.badge}><Sun size={14}/> Weekends</div>}
                            </div>
                        </div>
                    </div>

                    {/* --- RIGHT COLUMN: ACTIONS --- */}
                    <div className={styles.actions}>
                        <Button className={styles.primaryCta}>Phone: {profile.businesses.phone}</Button>
                        <div className={styles.secondaryActions}>
                            <a href={`tel:${profile.businesses.phone}`} className={styles.iconBtn}><Phone size={14} /> Call Now</a>
                            
                            
                            {showMessageButton && <Button className={styles.iconBtn} onClick={() => handleMessageClickConcise({businessuserid: profile.businessUserId})} ><MessageSquare size={14} /> Message</Button>}
                            
                            
                            <Button className={styles.iconBtn} onClick={handleSaveFavourite}>
                                <Bookmark size={14} fill={isSaved ? 'currentColor' : 'none'} /> {isSaved ? 'Saved' : 'Save'}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.profileModalContent}>
                <div className={styles.profileTabs}>
                    <div className={styles.profileTabsList}>
                        {/* Tab buttons - logic is unchanged */}
                        <button className={`${styles.profileTab} ${activeTab === "overview" ? styles.profileTabActive : ""}`} onClick={() => setActiveTab("overview")}>Overview</button>
                        <button className={`${styles.profileTab} ${activeTab === "reviews" ? styles.profileTabActive : ""}`} onClick={() => setActiveTab("reviews")}>Reviews ({profile.customerReviews?.length || 0})</button>
                        <button className={`${styles.profileTab} ${activeTab === "portfolio" ? styles.profileTabActive : ""}`} onClick={() => setActiveTab("portfolio")}>Work Portfolio</button>
                        {/* Add other tabs as needed */}
                    </div>
                  </div>

                <div className={styles.profileTabsContent}>
                    {activeTab === "overview" && (
                        <div className={styles.overviewGrid}>
                            {/* --- LEFT COLUMN IN OVERVIEW --- */}
                            <div className={styles.overviewMain}>
                                <div className={styles.section}>
                                    <h3 className={styles.sectionTitle}>About {profile.businesses.businessName}</h3>
                                    <p>{profile.businesses.profileDescription || "No detailed description provided."}</p>
                                </div>
                                <div className={styles.section}>
                                    <h3 className={styles.sectionTitle}><ListChecks /> Services Offered</h3>
                                    <div className={styles.tagContainer}>
                                        {profile.professions?.map(prof => <span key={prof.professionId} className={styles.tag}>{prof.name}</span>)}
                                        {profile.services?.map(service => <span key={service.serviceId} className={styles.tag}>{service.name}</span>)}
                                    </div>
                                </div>
                                 <div className={styles.section}>
                                    <h3 className={styles.sectionTitle}><Award /> Certifications & Qualifications</h3>
                                    <div className={styles.tagContainer}>
                                        {profile.certifications?.map(cert => <span key={cert.certificationId} className={styles.tag}>{cert.name}</span>)}
                                        {profile.qualificationDtos?.map(qual => <span key={qual.qualificationId} className={styles.tag}>{qual.name}</span>)}
                                    </div>
                                </div>
                            </div>
                            
                            {/* --- RIGHT COLUMN IN OVERVIEW --- */}
                            <div className={styles.overviewSidebar}>



<div className={styles.sidebarCard}>
    <h4 className={styles.cardTitle}><MapPin /> Location</h4>
    {primaryLocation ? (
        <div className={styles.locationSection}>
            <p>{primaryLocation.address}</p>
            {(primaryLocation.mobile || primaryLocation.landline) && (
                <div className={styles.locationPhone}>
                    <Phone size={14}/> {primaryLocation.mobile || primaryLocation.landline}
                </div>
            )}
            <button className={styles.directionsButton} onClick={() => getDirections(primaryLocation.address)}>
                Get Directions
            </button>
        </div>
    ) : <p>No primary location set.</p>}
    
    {profile.locations?.filter(loc => !loc.isPrimary).length > 0 && (
        <div className={styles.otherLocations}>
            <h5>Other locations</h5>
            <ul>
                {profile.locations?.filter(loc => !loc.isPrimary).map(location => (
                    <li key={location.locationId} className={styles.locationItem}>
                        <div className={styles.locationDetails}>
                            <p>{location.address}</p>
                            {(location.mobile || location.landline) && (
                                <div className={styles.locationPhone}>
                                    <Phone size={14}/> {location.mobile || location.landline}
                                </div>
                            )}
                        </div>
                        {/* Note the new class name here for consistent styling */}
                        <button className={styles.directionsButtonSecondary} onClick={() => getDirections(location.address)}>
                            Directions
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    )}
</div>


                                 <div className={styles.sidebarCard}>
                                    <h4 className={styles.cardTitle}><FileText /> Verification Details</h4>
                                    <div className={styles.verificationBox}>
                                        {profile.businesses.abn && <p><strong>ABN:</strong> {profile.businesses.abn}</p>}
                                        {profile.businesses.licenseNumber && <p><strong>License No:</strong> {profile.businesses.licenseNumber}</p>}
                                        {profile.businesses.registrationNumber && <p><strong>Registration No:</strong> {profile.businesses.registrationNumber}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === "reviews" && (
                      <div className={styles.profileReviews}>
                        <div className={styles.reviewsList}>
                          {profile.customerReviews && profile.customerReviews.length > 0 ? (
                            profile.customerReviews.map((review) => (
                              <Card key={review.reviewId} className={styles.reviewCard}>
                                <div className={styles.reviewContent}>
                                  <div className={styles.reviewHeader}>
                                    <div className={styles.reviewBusiness}>
                                      <Avatar
                                        className={styles.reviewAvatar}
                                        src={review.userProfileImage || "/placeholder.svg"}
                                        fallback={review.userName.charAt(0)}
                                      />
                                      <div className={styles.reviewBusinessInfo}>
                                        <div className={styles.reviewBusinessName}>
                                          {review.userName}
                                        </div>
                                      </div>
                                    </div>
                                    <div className={styles.reviewMeta}>
                                      <div className={styles.reviewRating}>{renderStars(review.overallRating)}</div>
                                    </div>
                                  </div>
                                  <div className={styles.reviewComment}>"{review.description}"</div>
                                </div>
                              </Card>
                            ))
                          ) : (
                            <p>No reviews available.</p>
                          )}
                        </div>
                      </div>
                    )}

                    {activeTab === "portfolio" && (
                      <div className={styles.portfolioSection}>
                          {profile.workPortfolio && profile.workPortfolio.model ? (
                              profile.workPortfolio.model.map(item => (
                                  <div key={item.portfolioId} className={styles.portfolioCard} onClick={() => setSelectedPortfolioItem(item)}>
                                      <img src={item.mediaUrl?.[0]?.url} alt={item.title} className={styles.portfolioImage} />
                                      <div className={styles.portfolioCardContent}>
                                          <h4 className={styles.portfolioTitle}>{item.title}</h4>
                                          <p className={styles.portfolioDescription}>{item.description}</p>
                                      </div>
                                  </div>
                              ))
                          ) : (
                              <p>No portfolio items available.</p>
                          )}
                      </div>
                    )}
                </div>
            </div>
          </>
        )}
      </div>

      {selectedPortfolioItem && (
          <PortfolioLightbox
              portfolioItem={selectedPortfolioItem}
              onClose={() => setSelectedPortfolioItem(null)}
          />
      )}
    </div>
  );
};

export default BusinessProfilePureCSS;
